<template>
    <div class="thematicActivity"
        :style="{ 'background': scrollBackgroudColor ? scrollBackgroudColor : '#F7F7F7'}">
        <login-in v-if="showLoginFlag"
            :loginType="loginType"
            :showLoginPop="true"
            :isLoginFlag="isLoginFlag"
            :activityTypeFlag="miniType"
            :activityUrl="activityUrl">
        </login-in>
        <div v-for="(item, index) in list"
            :key="index">
            <!-- 图片楼层 1*1 1*2 1*3 1*4 -->
            <div v-if="item.pageType=='image' || item.pageType=='imageactivity'"
                style="position: relative;">
                <hotPictures :activityObj="activityObj"
                    :miniType="miniType"
                    :env="env"
                    :loginType="loginType"
                    :hotPicturesData="item"
                    :miniprogramFlag="miniprogramFlag"></hotPictures>
            </div>

            <!-- 商品楼层 1*2-->
            <div v-if="(item.pageType=='spu' || item.pageType=='channelspu') && item.spuList"
                :class="{'goods':true,'sumOfReservationGuideBtn_height_Bottom': reservationGuideItem.serviceId}"
                :style="item.filePath&&item.backgroundType=='image' ? 'background:url('+ item.filePath +') no-repeat; background-size: 100% 100%;':'background:'+item.backgroundContent+';'">
                <template v-for="(spuItem, index1) in item.spuList">
                    <div v-if="spuItem.spuName"
                        :key="index1"
                        class="goods_item"
                        style="position: relative;">
                        <div class="goods_item_img">
                            <img :src="spuItem.imgPath"
                                alt="">
                        </div>
                        <div>
                            <div class="line-clamp-1"
                                style=" -webkit-box-orient: vertical; ">{{ spuItem.spuName }}</div>
                        </div>
                        <div v-if="spuItem.price"
                            style="font-size: 16px;">
                            <span style="font-size: 12px;">￥</span>
                            {{ spuItem.price }}
                        </div>
                        <!-- 跳小程序 -->
                        <!-- 在小程序内打开，或登录方式为支付宝时 -->
                        <div v-if="miniprogramFlag || loginType == 'Alipay'"
                            style="width: 150px; height: 220px; position: absolute; top: 17px;"
                            @click="backXcx(spuItem, item.pageType)"></div>
                        <!-- 不是在小程序内打开，且登录方式为微信时 -->
                        <div v-if="!miniprogramFlag && loginType == 'wechat'"
                            style="width: 100%; height: 100%; position: absolute; top: 17px;">
                            <!-- 跳转到HI荣耀微信小程序 -->
                            <wx-open-launch-weapp id="launch-btn"
                                :env-version="env"
                                :username="differentStores"
                                :path="item.pageType=='channelspu'
    ? `subpackages/index/pages/productDetails/product-details.html?storeId=${spuItem.channelCode || spuItem.storeId || spuItem.channelId}&thematicActivityCode=${activityCode}&spuCode=${spuItem.spuCode}&skuCode=${spuItem.skuCode}`
    : `subpackages/index/pages/productDetailsGlobal/product-details-global.html?spuCode=${spuItem.spuCode}&thematicActivityCode=${activityCode}`">
                                <script type="text/wxtag-template">
                                    <div style="width: 150px; height: 220px; display: block; opacity: 0; color: red; background: green;">打开小程序</div>
                                </script>
                            </wx-open-launch-weapp>
                        </div>
                    </div>
                </template>

            </div>

            <!-- 优惠券/免息券 1*1 1*2 -->
            <!-- useStatus => "01":未领用 "02":已领用 "03":已占用 "04":作废 "05":已使用 "06":已过期 "07":未到领取时间 "08":超过领取时间 "09":未到使用时间 "10":超过使用时间 "11":已领完 "12":已领完 -->
            <div v-if="['offinterest', 'coupon'].includes(item.pageType)">
                <div v-if="item.filePath && item.backgroundType == 'image'">
                    <img class="coupon-corner-img"
                        :src="item.filePath"
                        @click="toCorrespondingFloor(item)">
                </div>
                <div v-else
                    :style="'background:' + item.backgroundContent + ';'">
                    <offinterest-coupon :detail="item"
                        :miniprogramFlag="miniprogramFlag"
                        :serviceId="reservationGuideItem.serviceId"
                        :activityCode="activityCode"
                        :enableMessageNotifications="enableMessageNotifications"
                        :mobileVerification="mobileVerification"
                        :smallElementCoupon="smallElementCoupon"
                        :smallIndexCoupon="smallIndexCoupon"
                        :bigItemCoupon="bigItemCoupon"
                        @initData="initData"></offinterest-coupon>
                </div>
            </div>

            <!--个人中心-->
            <div v-if="item.pageType == 'personal'"
                style="position: relative;">
                <img :src="item.filePath"
                    alt="">
                <!-- 跳转模块 -->
                <div style="width: 100%; height: 100%; position: absolute; top: 0px; overflow: hidden;">
                    <!-- 在小程序内打开，或登录方式为支付宝时 -->
                    <div v-if="miniprogramFlag || loginType == 'Alipay'"
                        style="position: absolute; top: 0; width: 2000px; height: 2000px;"
                        @click="backXcx('', 'my')"></div>
                    <!-- 不是在小程序内打开，且登录方式为微信时 -->
                    <div v-if="!miniprogramFlag && loginType == 'wechat'">
                        <!-- HI荣耀小程序 -->
                        <wx-open-launch-weapp id="launch-btn"
                            :username="differentStores"
                            :env-version="env"
                            path="pages/tabBar/my/my">
                            <script type="text/wxtag-template">
                                <div style="width: 2000px; height: 2200px; display: block; opacity: 0; color: red; background: green;">打开小程序</div>
                            </script>
                        </wx-open-launch-weapp>
                    </div>
                </div>
            </div>

            <!--大转盘楼层-->
            <div v-if="item.pageType == 'draw'"
                @click="reportBigTurnableFloor(thematicAwardResult)">
                <raffleMain v-if="isAwardResponse"
                    :activityObj="thematicAwardResult"></raffleMain>
            </div>

            <!--视频播放楼层-->
            <div v-if="item.pageType == 'video'">
                <themaicVideo :filePath="item.filePath"
                    :posterPath="item.posterPath"></themaicVideo>
            </div>

            <!-- 权益品或者代金券楼层 -->
            <div v-if="item.pageType === 'voucher' || item.pageType === 'exchangegoods'">
                <div v-if="item.filePath&&item.backgroundType=='image'">
                    <img class="coupon-corner-img"
                        :src="item.filePath"
                        @click="toCorrespondingFloor(item)">
                </div>
                <div v-else>
                    <beneficial-products :detail="item"
                        :miniprogramFlag="miniprogramFlag"
                        :enableMessageNotifications="enableMessageNotifications"
                        :mobileVerification="mobileVerification"
                        :smallIndexExchangeGoods="smallIndexExchangeGoods"
                        :bigItemExchangeGoods="bigItemExchangeGoods"
                        @paused="handelPaused"
                        @initData="initData"></beneficial-products>
                </div>
            </div>
            <!-- 权益包楼层 -->
            <div v-if="item.pageType === 'group'">
                <div v-if="item.filePath&&item.backgroundType=='image'">
                    <img class="coupon-corner-img"
                        :src="item.filePath"
                        @click="toCorrespondingFloor(item)">
                </div>
                <equity-package v-else
                    class="equity-package-padding"
                    :detail="item"
                    :miniprogramFlag="miniprogramFlag"
                    :enableMessageNotifications="enableMessageNotifications"
                    :mobileVerification="mobileVerification"
                    :smallIndexExchangeGoods="smallIndexExchangeGoods"
                    :bigItemExchangeGoods="bigItemExchangeGoods"
                    @paused="handelPaused"
                    @initData="initData"></equity-package>
            </div>
            <!-- 社群活码楼层 -->
            <div v-if="item.pageType ==='communitycode'"
                class="live-code">
                <live-code-picture ref="liveCodePicture"
                    :activityCode="activityCode"
                    :loginType="loginType"
                    :channelCode="channelCode"
                    :isLoginFlag="isLoginFlag"
                    :pageType="type"
                    :picturesData="item"></live-code-picture>
            </div>
            <!-- 企微活码楼层 -->
            <div v-if="item.pageType === 'guidecode'"
                class="live-code">
                <live-code-picture :activityCode="activityCode"
                    :loginType="loginType"
                    :isLoginFlag="isLoginFlag"
                    :pageType="item.pageType"
                    :picturesData="item"></live-code-picture>
            </div>
        </div>

        <a id="links"
            href="#"
            style="display:none"></a>
        <div v-if="projectSecond && projectSecond >0"
            class="countdownTime">
            倒计时{{ projectSecond }}s
        </div>

        <!-- 图片楼层1*1类型 有预约导购  跳转预约导购 -->
        <div v-if="reservationGuideItem.serviceId"
            class="appointment">
            <div class="appointment-wrap">
                <van-button round
                    type="info"
                    class="appointment-btn"
                    @click="jumpAppointmentGuide">
                    <div>预约{{ reservationGuideItem.serviceContent }}</div>
                </van-button>
            </div>
        </div>
        <!-- 悬浮按钮 -->
        <div v-if="floatButtonConfig.show"
            class="float-button"
            @click="handleFloatButtonClick">
            <img :src="floatButtonConfig.imgUrl"
                alt="悬浮按钮">
        </div>
        <!-- 活动未开始、已暂停、已结束弹窗 -->
        <activity-status-dialog ref="activityStatusDialogRef"
            :activityStatus="activityStatus"
            :activityStartDate="activityStartTime"
            :activityEndDate="activityEndTime"></activity-status-dialog>
        <!-- 活动楼层有大转盘楼层时不显示这个弹窗 -->
        <IncorrectClient v-if="!drawFlag"
            :isDisplay="!isCorrectClient"
            :loginType="originLoginType"></IncorrectClient>
    </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { Dialog, Button, Toast, CountDown, Icon } from 'vant';
import raffleMain from './lucky-draw/raffle-main.vue';
import hotPictures from './themaicComponent/hot-pictures';
import liveCodePicture from './themaicComponent/live-code-picture';
import themaicVideo from './themaicComponent/themaic-video';
import themaicCountDown from './themaicComponent/themaic-count-down';
import beneficialProducts from './themaicComponent/beneficial-products';
import equityPackage from './themaicComponent/equity-package';

// 免息券优惠券组件
import offinterestCoupon from './themaicComponent/offinterest-coupon';
import utils, { loadAlipayWebViewScript } from '../../../utils/comUtils.js';
import { config } from '../../../api/config';
import { config as configEnv } from '../../../commons/config.js';
import { AMapGetLocation } from './TMap';
import loginIn from './dynamicAttr/modal/login-in.vue';
import ActivityStatusDialog from './themaicComponent/activity-status-dialog.vue';
import IncorrectClient from './dynamicAttr/incorrect-client.vue';
import { ActivityStatus, LoginType, MiniType, PMLinkType, IdentityVerify, CustomerGroup, CouponType, SkuScopeType } from '../../../commons/commonVariables';
import { jumpToPointsMall, checkClient, pointsMallLinkJudge, getGoodsList, couponDataHandler } from './common-methods/utils';

export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Toast.name]: Toast,
    [CountDown.name]: CountDown,
    hotPictures,
    themaicVideo,
    themaicCountDown,
    beneficialProducts,
    equityPackage,
    loginIn,
    liveCodePicture,
    raffleMain,
    offinterestCoupon,
    ActivityStatusDialog,
    IncorrectClient
  },
  props: {
    activityObj: Object
  },
  data() {
    return {
      countColor: '#FFFFFF',
      blockColor: '#000',
      blockBackgroundColor: '#FFFFFF',
      type: '',
      channelCode: '',
      list: [],
      projectOtherSet: '0',
      projectSecond: '',
      miniprogramFlag: false, //判断是否在小程序打开
      isAwardResponse: false,
      loginType: '', //登入类型
      miniType: MiniType.HiHonor, //小程序类型，1是Hi荣耀，2是直营店
      spuBrandList: [],
      differentStores: config.otherConfig.hiHonorWxAppId,
      differPath: 'pages/tabBar/my/my', //hi荣耀个人中心跳转路径pages/tabBar/my/my 直营店个人中心跳转路径/pages/index?showTab=My
      shareType: '',
      activityCode: '',
      userUnionid: '',
      alipayUserId: '',
      userBase: '',
      thematicAwardResult: '',
      activityUrl: '',
      position: {}, // 定位的地址
      link: '', //请求地址
      option: { timeout: 60000 },
      env: configEnv.env === 'pro' ? 'release' : 'trial', // 判断当前环境变量，env-version默认正式版release，为方便测试增加体验版trial跳转
      scrollBackgroudColor: '', // 背景颜色
      isOpenReservationGuide: false,
      reservationGuideItem: {},
      isLoginFlag: false, // 默认没有登录
      showLoginFlag: false,
      bigTurnableReportFlag: false, // 大转盘楼层上报标识，TRUE表示已经上报过，不再重复上报
      activityPageList: [],
      enableMessageNotifications: '', //是否开启消息订阅通知  0未开启  1开启
      activityStatus: '', // 当前活动状态
      activityStartTime: '',
      activityEndTime: '',
      isCorrectClient: true, // 是否在正确的客户端打开
      originLoginType: '', // 原始登录类型（转换前）
      drawFlag: false,
      mobileVerification: '', //顾客身份 0:不限制；3-2:芝麻身份-教师；3-1:学生；3-3:医护；2-1:老用户；2-2:新用户
      smallElementCoupon: {},
      bigItemCoupon: {},
      smallIndexCoupon: null,
      bigItemExchangeGoods: {},
      smallIndexExchangeGoods: null,
      activityName: '',
      // 悬浮按钮配置
      floatButtonConfig: {
        show: false, // 是否显示（根据 projectFloatButtonSwitch 判断）
        imgUrl: '', // 按钮图片地址（projectFloatButtonImgUrl）
        jumpUrl: '' // 跳转路径（projectFloatButtonJumpUrl）
      }
    };
  },
  created() {
    // 初始化用户信息
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    this.userBase = Object.assign({}, userInfo);
    this.loginType = sessionStorage.getItem('loginType') || '';
    this.shareType = sessionStorage.getItem('shareType') || '';
    this.activityCode = (this.activityObj && this.activityObj.activityCode) || '';
    this.userUnionid = sessionStorage.getItem('userUnionid') || '';
    this.alipayUserId = sessionStorage.getItem('alipayUserId') || '';
    const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
    // 小程序/积分商城传过来的经纬度信息，如果没有传经纬度信息，需要h5拉起位置授权获取经纬度信息
    const locationInfo = JSON.parse(sessionStorage.getItem('locationInfo')) || {};
    this.position.longitude = locationInfo.longitude || '';
    this.position.latitude = locationInfo.latitude || '';
    // 组装当前地址
    this.activityUrl = location.origin + '/hd/hdmain?activityCode=' + this.activityCode;
    if (eventTrackingData && eventTrackingData.storeCode && eventTrackingData.guideUserId) {
      this.activityUrl =
        this.activityUrl + '&ay=' + eventTrackingData.activityType + '&GUID=' + eventTrackingData.guideUserId + '&SC=' + eventTrackingData.storeCode;
    }
    // 打开方式是微信时，判断是否有登陆
    this.isLoginFlag = sessionStorage.getItem('isLoginFlag') === 'true' || sessionStorage.getItem('isLoginFlag') === true ? true : false;
    this.initData();
  },
  //初始化后调用
  mounted() {
    this.originLoginType = sessionStorage.getItem('originLoginType');
    this.isCorrectClient = checkClient(this.originLoginType);
    this.checkDom('launch-btn-toMy', dom => {
      dom.addEventListener('launch', () => {
        console.log('跳转了吗');
        this.handleCenterThematicActivityProcess();
      });
    });
  },
  computed: {
    handleWxOpenLaunch() {
      return function(link, length) {
        let width = window.screen.width;
        return `<wx-open-launch-weapp
            id="launch-btn"
            username="gh_c31414cf312a"
            env-version="${this.env}"
            path="${link.slice(1)}">
            <template>
              <button style="width: ${((100 / length) * width) /
                100}px;height: 220px; opacity: 0; display: block; color: red; background: green;">${link}</button>
            </template>
          </wx-open-launch-weapp>`;
      };
    }
  },
  methods: {
    backgroundStyle(item) {
      const style = {};
      if (!item) {
        return style;
      } else if (item.filePath && item.backgroundType === 'image') {
        style.background = `url('+ ${item.filePath}+') no-repeat`;
      } else {
        style.backgroundColor = item.backgroundColor;
      }
      return style;
    },
    // 打开对应楼层
    toCorrespondingFloor(item) {
      const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
      let src = '';
      if (['offinterest', 'coupon'].includes(item.pageType)) {
        src = '/offinterestCoupon';
      } else if (['voucher', 'exchangegoods'].includes(item.pageType)) {
        src = '/beneficialProducts';
      } else if (['group'].includes(item.pageType)) {
        src = '/equityPackage';
      }
      let path = `${src}?pageId=${item.id}&pageType=${item.pageType}&activityCode=${this.activityCode}&serviceId=${this.reservationGuideItem.serviceId}&backgroundType=image&miniprogramFlag=${this.miniprogramFlag}&mobileVerification=${this.mobileVerification}`;
      if (eventTrackingData && eventTrackingData.storeCode && eventTrackingData.guideUserId) {
        path =
          path +
          +'&ay=' +
          eventTrackingData.activityType +
          '&GUID=' +
          eventTrackingData.guideUserId +
          '&SC=' +
          eventTrackingData.storeCode +
          '&activityName=' +
          this.activityName;
      }
      this.$router.push({
        path: path
      });
    },
    // 跳转预约导购
    jumpAppointmentGuide() {
      const whichPageOrigin = 'h5ThematicActivity_ReservationGuide';
      const jumpUrl =
        `/subpackages/activity/pages/shoppersService/createService/create-service` +
        `?whichPageOrigin=${whichPageOrigin}` +
        `&serviceType=${encodeURIComponent(this.reservationGuideItem.serviceType) || ''}` +
        `&serviceContent=${encodeURIComponent(this.reservationGuideItem.serviceContent) || ''}` +
        `&channelNavigationCode=${this.reservationGuideItem.channelNavigationCode || ''}` +
        `&positionType=${this.reservationGuideItem.positionType || ''}` +
        `&relationActivityTag=1` +
        `&activityCode=${this.activityCode}`;
      console.log('打印跳转地址', jumpUrl, this.loginType);
      if (this.loginType === LoginType.Wechat || this.loginType === LoginType.None) {
        wx.miniProgram.navigateTo({
          url: jumpUrl
        });
        console.log('打印跳转地址1', wx.miniProgram);
      } else {
        my.navigateTo({
          url: jumpUrl
        });
      }
    },
    async getLocationMethods(type) {
      Toast.loading({
        message: '定位中...',
        forbidClick: true,
        duration: 0
      });
      this.position = await AMapGetLocation();
      console.log('当前的位置信息================this.position', this.position);
      if (this.position.status === 'complete') {
        this.showPosition(type);
      } else if (this.position.status === 'error') {
        this.showErr(type);
      }
      Toast.clear();
    },
    showPosition(type) {
      const locationInfo = JSON.parse(sessionStorage.getItem('locationInfo')) || {};
      const longitude = locationInfo.longitude || '';
      const latitude = locationInfo.latitude || '';
      if (longitude && latitude) {
        this.position.longitude = longitude;
        this.position.latitude = latitude;
      }
      Toast.clear();
      if (type === 'communitycode') {
        this.list.forEach((item, index) => {
          if (item.link) {
            this.goWork(item.link, index);
          }
        });
      } else {
        this.goWork(this.link);
      }
    },
    showErr(type) {
      Toast.clear();
      if (type === 'communitycode') {
        this.list.forEach((item, index) => {
          if (item.link) {
            this.goWork(item.link, index);
          }
        });
      } else {
        const isWeChat = this.isWeChat();
        let content = '';
        if (isWeChat) {
          content = '获取地理位置失败，请在手机设置里打开微信位置，授权允许访问才能继续使用本次服务';
        } else {
          content = '获取地理位置失败，请在手机设置里打开浏览器位置，授权允许访问才能继续使用本次服务';
        }
        Dialog.alert({
          title: '提示',
          message: content
        });
      }
    },
    checkDom(id, callback) {
      let time = '';
      function checkIn() {
        let dom = document.getElementById(id);
        if (dom) {
          callback(dom);
          if (!time) clearTimeout(time);
        } else {
          time = setTimeout(checkIn, 10);
        }
      }
      checkIn();
    },
    // 埋码事件：点击(专题页)首页商品楼层
    handleIndexThematicActivityProcess(spuResult) {
      const params = {
        actionCode: 400060004,
        actionName: '首页商品楼层',
        content: {
          title: '首页商品楼层',
          channel: this.loginType == 'none' ? '' : this.loginType == 'wechat' ? '微信' : '支付宝',
          shareType: this.shareType == 'undefined' ? '' : this.shareType,
          activityCode: this.activityCode,
          spuCode: spuResult.spuCode,
          spuName: spuResult.spuName
        }
      };
      const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
      if (eventTrackingData.storeCode && eventTrackingData.guideUserId) {
        params.content.activityName = eventTrackingData.activityName;
        params.content.activityType = eventTrackingData.activityType;
        params.content.guideUserId = eventTrackingData.guideUserId;
        params.content.channelCode = eventTrackingData.storeCode;
      }
      utils.handleBatchReport(this, params);
    },
    // 埋码事件：点击(专题页)门店商品楼层
    handleStoreThematicActivityProcess(spuResult) {
      const params = {
        actionCode: 400060005,
        actionName: '门店商品楼层',
        content: {
          title: '门店商品楼层',
          channel: this.loginType == 'none' ? '' : this.loginType == 'wechat' ? '微信' : '支付宝',
          shareType: this.shareType == 'undefined' ? '' : this.shareType,
          activityCode: this.activityCode,
          spuCode: spuResult.spuCode,
          spuName: spuResult.spuName
        }
      };
      this.setEventTrackingData(params);
      utils.handleBatchReport(this, params);
    },

    // 埋码事件：点击(专题页)图片楼层
    handleImgThematicActivityProcess(linkUrl) {
      const params = {
        actionCode: 400060007,
        actionName: '图片楼层',
        content: {
          title: '图片楼层',
          channel: this.loginType == 'none' ? '' : this.loginType == 'wechat' ? '微信' : '支付宝',
          shareType: this.shareType == 'undefined' ? '' : this.shareType,
          url: linkUrl
        }
      };
      this.setEventTrackingData(params);
      utils.handleBatchReport(this, params);
    },
    // 埋码事件：点击(专题页)个人中心
    handleCenterThematicActivityProcess() {
      const params = {
        actionCode: 400060008,
        actionName: '个人中心',
        content: {
          title: '个人中心',
          channel: this.loginType == 'none' ? '' : this.loginType == 'wechat' ? '微信' : '支付宝',
          shareType: this.shareType == 'undefined' ? '' : this.shareType
        }
      };
      this.setEventTrackingData(params);
      utils.handleBatchReport(this, params);
    },
    /**
     * 大转盘楼层上报
     */
    reportBigTurnableFloor(obj) {
      if (!this.bigTurnableReportFlag) {
        this.bigTurnableReportFlag = true;
        let params = {
          actionCode: '400060001',
          actionName: '进入大转盘',
          content: {
            title: '进入大转盘',
            channel: obj.loginType == 'none' ? '无需登陆' : obj.loginType == 'wechat' ? '微信' : '支付宝',
            shareType: this.shareType ? this.shareType : '',
            activityCode: obj.activityCode,
            parentPage: 'thematicActivity',
            parentActivityCode: this.activityCode
          }
        };
        // 如果session缓存中存在eventTrackingData，则将storeCode存入content中
        const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
        if (eventTrackingData && eventTrackingData.storeCode) {
          params.content.channelCode = eventTrackingData.storeCode;
        }
        this.setEventTrackingData(params);
        utils.handleBatchReport(this, params);
        this.handleNumberOfScans(obj.activityCode);
      }
    },
    // 消费打开链接或者小程序卡片，需要把导购企微id、活动名称、活动类型、门店编码进行埋码
    setEventTrackingData(params) {
      const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
      if (eventTrackingData && eventTrackingData.storeCode && eventTrackingData.guideUserId) {
        params.content.activityName = eventTrackingData.activityName;
        params.content.activityType = eventTrackingData.activityType;
        params.content.guideUserId = eventTrackingData.guideUserId;
        params.content.channelCode = eventTrackingData.storeCode;
      }
    },
    // 统计扫码次数
    handleNumberOfScans(param) {
      const params = {
        activityCode: '',
        channel: 'magicActivity'
      };
      if (param) {
        params.activityCode = param;
      }
      console.log('纪录扫码、链接进入活力魔方活动次数====params', params);
      if (params.activityCode && params.activityCode.substr(0, 2) === 'HD') {
        this.$api.post({
          sc: 'mobileMarketing',
          url: 'miniMemberAndCommunityStatistics/countJoinMemberScanNum',
          params
        });
      }
    },
    handleActivityQuery(code) {
      this.$api.post({
        noLoading: true,
        sc: 'mobileMarketingH5',
        url: 'navigationActivity/getByActivityIdForH5?idOrCode=' + code,
        success: r => {
          let result = r.result || {};
          this.thematicAwardResult = result;
          this.isAwardResponse = true;
        }
      });
    },
    initData() {
      //  活动列表查询
      const loginType = this.loginType === LoginType.Wechat ? 'wxapp' : this.loginType === LoginType.Alipay ? 'alipaymini' : '';
      this.$api.post({
        sc: 'mobileMarketing',
        url: 'h5/projectActivity/queryActivityProject',
        //如果为空，就传空参数，登陆类型为微信登陆但没有登陆时，unionId需要传空字符
        notFilterNull: true,
        params: {
          activityCode: this.activityObj.activityCode,
          unionId: this.userUnionid,
          alipayUserId: this.alipayUserId,
          loginType: loginType
        },
        success: async r => {
          let { code, result, message } = r;
          if (code == 200 && result) {
            let { activityPageList = [], activityName, projectOtherSet, projectSecond, projectUrl, activityStatus, enableMessageNotifications } = result;
            if (result) {
              this.activityName = activityName || '';
              this.activityStartTime = result.activityStartTime || '';
              this.activityEndTime = result.activityEndTime || '';
            }
            //设置浏览器title
            document.title = activityName || '';
            this.enableMessageNotifications = enableMessageNotifications;

            // hi荣耀
            this.differentStores = config.otherConfig.hiHonorWxAppId;
            this.differPath = 'pages/tabBar/my/my';

            // 获取登录类型后分宿主环境判断是否在小程序内
            this.handleMiniprogramJudge();
            this.activityPageList = [];
            let isGetMobileBrand = false;
            // 找到如果activityPageList每个对象里面的couponMainVOList || exchangeGoodsVOList的每个对象如果存在2-1老用户或者2-2新用户就调老用户厂商列表接口
            if (Array.isArray(activityPageList) && activityPageList.length) {
              isGetMobileBrand = activityPageList.some(item => {
                if (
                  (Array.isArray(item.couponMainVOList) && item.couponMainVOList.length) ||
                  (Array.isArray(item.exchangeGoodsVOList) && item.exchangeGoodsVOList.length) ||
                  (Array.isArray(item.activityPageRewardSettingList) && item.activityPageRewardSettingList.length)
                ) {
                  if (Array.isArray(item.couponMainVOList) && item.couponMainVOList.length) {
                    return item.couponMainVOList.some(
                      el => el.userAuthenticationValue === IdentityVerify.oldUser || el.userAuthenticationValue === IdentityVerify.newUser
                    );
                  } else if (Array.isArray(item.exchangeGoodsVOList) && item.exchangeGoodsVOList.length) {
                    return item.exchangeGoodsVOList.some(
                      el => el.userAuthenticationValue === IdentityVerify.oldUser || el.userAuthenticationValue === IdentityVerify.newUser
                    );
                  } else if (Array.isArray(item.activityPageRewardSettingList) && item.activityPageRewardSettingList.length) {
                    return item.activityPageRewardSettingList.some(
                      el => el.userAuthenticationValue === IdentityVerify.oldUser || el.userAuthenticationValue === IdentityVerify.newUser
                    );
                  } else {
                    return false;
                  }
                } else {
                  return false;
                }
              });
            }
            if (isGetMobileBrand) {
              await this.getOldCustomerBrand().finally(() => {
                this.initDataResult(result);
              });
            } else {
              this.initDataResult(result);
            }
          }
        }
      });
    },
    async initDataResult(result) {
      let spuCodeList = [];
      let { activityPageList = [], projectOtherSet, projectSecond, projectUrl, activityStatus } = result;
      // 若无位置信息，则首先获取定位(配有社群活码楼层时)
      if (activityPageList.some(item => item.pageType === 'communitycode') && !(this.position.longitude && this.position.latitude)) {
        this.position = await AMapGetLocation();
      }
      activityPageList.forEach(async (item, index) => {
        let { pageType, imgUrl, imgStyle, couponcodesOrSpuids, backgroundContent, activityPageRewardSettingList } = item;
        //图片楼层
        if (pageType == 'image' || pageType == 'imageactivity' || !pageType) {
          imgUrl = JSON.parse(imgUrl);
          item.filePath = this.$utils.getImageUrl(imgUrl.file);
          // 图片楼层，跳转微信小程序
          if (pageType == 'imageactivity') {
            item.hrefFirst = item.hrefFirst && item.hrefFirst.indexOf('}') > -1 ? JSON.parse(item.hrefFirst) : '';
          }
          item.linkList = [item.hrefFirst, item.hrefSecond, item.hrefThird, item.hrefFour];
          //默认为4个长度，以实际类型为准
          item.linkList.length = Number(imgStyle);
        } else if (['coupon', 'offinterest'].includes(pageType)) {
          item = Object.assign(item, couponDataHandler(result, item));
          item.couponMainVOList.forEach(el => {
            this.showClaimNowButton(el);
          });
          if (pageType === 'coupon') {
            this.handleBackH5(item);
          }
        } else if ((pageType == 'spu' || pageType == 'channelspu') && couponcodesOrSpuids) {
          //商品楼层
          if (imgUrl) {
            imgUrl = JSON.parse(imgUrl);
            item.filePath = this.$utils.getImageUrl(imgUrl.file);
          }
          let spuCodeObj = JSON.parse(couponcodesOrSpuids);
          spuCodeObj.forEach(pItem => {
            let { spuCode } = pItem;
            spuCodeList.push(spuCode);
          });
          item.spuList = spuCodeObj;
        } else if (pageType == 'personal') {
          //个人中心楼层
          imgUrl = JSON.parse(imgUrl);
          item.filePath = this.$utils.getImageUrl(imgUrl.file);
        } else if (pageType == 'draw') {
          //大转盘楼层
          let drawCode = couponcodesOrSpuids;
          this.handleActivityQuery(drawCode);
        } else if (pageType == 'video' && imgUrl) {
          //视频楼层
          imgUrl = JSON.parse(imgUrl);
          item.filePath = this.$utils.getImageUrl(imgUrl.file, 'video');
          //封面图片
          if (backgroundContent) {
            backgroundContent = JSON.parse(backgroundContent);
            item.posterPath = this.$utils.getImageUrl(backgroundContent.file);
          }
        } else if (pageType === 'voucher' || pageType === 'exchangegoods') {
          // 权益品楼层和代金券楼层
          if (imgUrl) {
            imgUrl = JSON.parse(imgUrl);
            item.filePath = this.$utils.getImageUrl(imgUrl.file);
          }
          // 获取角标图片路径(代金券才有)
          if (result.activityConfig && result.activityConfig.voucherCornerPic) {
            const voucherCornerPic = JSON.parse(result.activityConfig.voucherCornerPic);
            item.voucherCornerPic = this.$utils.getImageUrl(voucherCornerPic.file || '');
          }
          this.$set(item, 'goodsList', getGoodsList(result, item));
          item.goodsList.forEach(el => {
            this.showClaimNowButton(el);
          });
          this.handleBackH5(item);
        } else if (pageType === 'group') {
          // 权益包楼层
          if (imgUrl) {
            imgUrl = JSON.parse(imgUrl);
            item.filePath = this.$utils.getImageUrl(imgUrl.file);
          }
          const packageInfo = item.activityPageRewardSettingList[0];
          console.log('packageInfo', packageInfo);
          item.mainImg = this.$utils.getImageUrl(JSON.parse(packageInfo.goodsPictureUrl).file);
          item.packageName = packageInfo.exchangeGroupName;
          item.showRemainingAmountWay = result.showRemainingAmountWay;
          item.balanceAmount = packageInfo.remainingNum;
          item.groupUseFlag = packageInfo.groupUseFlag;
          // 获取角标图片路径(代金券才有)
          if (result.activityConfig && result.activityConfig.voucherCornerPic) {
            const voucherCornerPic = JSON.parse(result.activityConfig.voucherCornerPic);
            item.voucherCornerPic = this.$utils.getImageUrl(voucherCornerPic.file || '');
          }
          // 获取角标图片路径(优惠券才有)
          if (result.activityConfig && result.activityConfig.couponCornerPic) {
            const couponCornerPic = JSON.parse(result.activityConfig.couponCornerPic);
            item.couponCornerPic = this.$utils.getImageUrl(couponCornerPic.file || '');
          }
          // 获取立即领取-按钮图片路径
          if (result.receiveButtonImgUrl) {
            const receiveButtonImgUrl = JSON.parse(result.receiveButtonImgUrl);
            item.receiveButtonImgUrl = this.$utils.getImageUrl(receiveButtonImgUrl.file || '');
          } else {
            item.receiveButtonImgUrl = require('../../../../static/runtime/images/magic/receiveButtonImgUrl.png');
          }
          // 获取不可领取-按钮图片路径
          if (result.notReceiveButtonImgUrl) {
            const notReceiveButtonImgUrl = JSON.parse(result.notReceiveButtonImgUrl);
            item.notReceiveButtonImgUrl = this.$utils.getImageUrl(notReceiveButtonImgUrl.file || '');
          } else {
            item.notReceiveButtonImgUrl = require('../../../../static/runtime/images/magic/notReceiveButtonImgUrl.png');
          }
          this.$set(item, 'goodsList', getGoodsList(result, item));
          item &&
            item.activityPageRewardSettingList.forEach(el => {
              this.showClaimNowButton(el);
            });
          item.goodsList.forEach(el => {
            this.showClaimNowButton(el);
          });
          this.handleBackH5(item);
        } else if (pageType === 'communitycode') {
          this.type = 'communitycode';
          item.link = activityPageRewardSettingList[0].communityJoinPath;
          if (item.link) {
            // 活码楼层
            imgUrl = JSON.parse(imgUrl);
            item.filePath = this.$utils.getImageUrl(imgUrl.file);
            // 小程序/积分商城传过来的经纬度信息，如果没有传经纬度信息，需要h5拉起位置授权获取经纬度信息
            if (this.position.longitude && this.position.latitude) {
              this.goWork(item.link, index);
            } else {
              await this.getLocationMethods('communitycode');
            }
          }
        } else if (pageType === 'guidecode') {
          imgUrl = JSON.parse(imgUrl);
          item.filePath = this.$utils.getImageUrl(imgUrl.file);
        }
      });
      this.list = this.dealActiveData(activityPageList);
      //解析悬浮按钮配置
      const { projectFloatButtonSwitch, projectFloatButtonImgUrl, projectFloatButtonJumpUrl } = result;
      if (projectFloatButtonSwitch === '1' && projectFloatButtonImgUrl) {
        this.floatButtonConfig = {
          show: true,
          imgUrl: this.$utils.getImageUrl(projectFloatButtonImgUrl),
          jumpUrl: projectFloatButtonJumpUrl || ''
        };
      } else {
        this.floatButtonConfig.show = false;
      }
      // 如果是单活动是图片，视频，商品楼层是不需要登录 ，如果混合的也只是这几种的也不需要显示登入，其他场景没登入显示悬浮登入按钮
      const factPageTypeArr = this.list.map(item => item.pageType); // 页面实际存在的图片楼层
      // 需要显示登陆的图片楼层，包括优惠券、个人中心、大转盘、权益品、代金券、支付宝分期免息券、社群活码楼层、企微导购活码楼层
      const needLoginPageArr = ['coupon', 'personal', 'draw', 'voucher', 'exchangegoods', 'communitycode', 'image', 'offinterest', 'group', 'guidecode'];
      // 求交集，有交集说明需要拉起微信登陆
      const mixedArr = needLoginPageArr.filter(item => {
        return factPageTypeArr.indexOf(item) > -1;
      });
      // 如果交集存在，则需要显示登陆按钮
      this.showLoginFlag = mixedArr.length > 0;
      this.activityStatus = activityStatus;
      if (this.activityStatus !== ActivityStatus.running) {
        this.$refs.activityStatusDialogRef.open();
      }
      if (spuCodeList.length > 0) {
        this.handleGetProduct(spuCodeList, activityPageList);
      }
      //倒计时逻辑
      if (projectOtherSet != '0') {
        let timer = setInterval(() => {
          this.projectSecond = projectSecond;
          if (this.projectSecond == 0) {
            clearInterval(timer);
            this.linkTo(result && projectUrl);
            projectSecond = '';
          }
          projectSecond--;
        }, 1000);
      }
      // 跳转预约导购逻辑   列表里找到预约导购数据
      this.reservationGuideItem =
        this.list.find(item => {
          return item.serviceId; // 找到serviceId 有值的
        }) || {};
      const isSroll = document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight);
      if (!isSroll) {
        setTimeout(() => {
          this.scrollBackgroudColor = result.scrollBackgroudColor || '';
        }, 500);
      }
    },
    // 是否满足新老用户限制条件判断
    showClaimNowButton(el) {
      const mobileVerification = this.mobileVerification;
      // 为新老用户，则判断身份是否符合，符合则显示立即领取，不符合则显示不可领取
      el.isShow = true;
      if ([CustomerGroup.newOldUser].includes(el.restrictType) && el.userAuthenticationValue !== mobileVerification) {
        el.isShow = false;
      }
    },
    handleFloatButtonClick() {
      const { jumpUrl } = this.floatButtonConfig;
      if (!jumpUrl) return;
      this.linkTo(jumpUrl);
    },
    handleBackH5(item) {
      const isClickNextPage = sessionStorage.getItem('isClickNextPage');
      const clickIndex = sessionStorage.getItem('clickIndex');
      const clickListId = sessionStorage.getItem('clickListId'); // 对于芝麻身份 学生 教师 医护的券点击时会记录该点击item的父数组的id
      let findItemObj = {};
      if (clickListId && item.id === clickListId) {
        findItemObj = item;
        const isFirstJump = sessionStorage.getItem('isFirstJump') || 'true';
        if (isClickNextPage === 'true' && isFirstJump === 'true') {
          sessionStorage.setItem('isFirstJump', 'false');
          this.toCorrespondingFloor(findItemObj);
        } else if (isClickNextPage === 'false') {
          if ([CouponType.exchangegoods, CouponType.voucher, CouponType.EQUITY_PACKAGE].includes(findItemObj.pageType)) {
            this.bigItemExchangeGoods = findItemObj;
            this.smallIndexExchangeGoods = clickIndex;
          } else if (findItemObj.pageType === CouponType.coupon) {
            this.smallElementCoupon = findItemObj.couponMainVOList[clickIndex];
            this.bigItemCoupon = findItemObj;
            this.smallIndexCoupon = clickIndex;
          }
        }
      }
    },
    /**
     * 获取老用户手机厂商
     */
    getOldCustomerBrand() {
      // 接口返回老用户手机厂商列表
      let oldUserPhoneList = JSON.parse(sessionStorage.getItem('oldUserPhoneList')) || '';
      // 这个变量用来存储当前顾客手机厂商是老用户，还是新用户，老用户存储2-1，新用户存储2-2
      this.mobileVerification = sessionStorage.getItem('mobileVerification') || '';
      return new Promise((resolve, reject) => {
        if (!this.mobileVerification || !oldUserPhoneList) {
          this.$api.post({
            sc: 'mobileMarketing',
            url: '/miniCouponManager/obtainOldCustomerBrand',
            params: {},
            success: r => {
              console.log('老用户厂商', r);
              let oldUserPhoneList = [];
              let deviceBrand = sessionStorage.getItem('deviceBrand');
              if (r.code == 200 && r.result) {
                // 这个接口返回的都是老用户厂商列表
                oldUserPhoneList = r.result.map(item => {
                  return item.toLowerCase();
                });
                if (oldUserPhoneList.includes(deviceBrand)) {
                  // 表示老用户
                  this.mobileVerification = IdentityVerify.oldUser;
                } else {
                  // 表示新用户
                  this.mobileVerification = IdentityVerify.newUser;
                }
                resolve();
                sessionStorage.setItem('oldUserPhoneList', JSON.stringify(oldUserPhoneList));
                sessionStorage.setItem('mobileVerification', this.mobileVerification);
              }
            },
            failure: () => {
              reject('未获取老用户厂商列表');
            }
          });
        } else {
          resolve();
        }
      });
    },

    /**
     * 图片楼层跳转逻辑
     * @param {string} link 跳转链接
     * @param {Object} item 传入图片楼层组件的hotPicturesData字段
     * @param {number} linkIndex （非必填）跳转链接link对应的项，在item数组里面的下标
     */
    async linkTo(link, item, linkIndex = -1) {
      console.log('图片楼层跳转逻辑', link, item, linkIndex);
      // 获取当前图片热区的跳转配置，其中 miniAppId 对应目标第三方小程序
      const linkConfig = linkIndex > -1 && item && item.linksArray ? item.linksArray[linkIndex] : null;
      // 小程序 WebView 中配置第三方 miniAppId 时，通过Hi荣耀小程序中转页跳转目标小程序
      const canJumpThirdPartyMiniProgram = linkConfig && linkConfig.miniAppId && this.loginType === 'wechat' && this.miniprogramFlag;
      if (canJumpThirdPartyMiniProgram) {
        const transferPageUrl = `/subpackages/activity/pages/transferPage/transferPage?appId=${encodeURIComponent(
          linkConfig.miniAppId
        )}&path=${encodeURIComponent(linkConfig.url || '')}`;
        wx.miniProgram.navigateTo({ url: transferPageUrl });
        return;
      }
      if (link) {
        const currentOrigin = window.location.origin;
        const self = this;
        if (item) {
          await this.recordClickEvent(link, item);
        }
        // 如果link带http，也就是h5或者链接，活动需要登录且没有登录，就要先拉起登录
        // 需要登录且没有登录，需要拉起登录再往下走
        if (!this.isLoginFlag && (this.loginType === 'wechat' || this.loginType === 'Alipay') && link.indexOf('http') > -1) {
          this.handleMiniProgramLogin(); // 处理登录逻辑
          return;
        }
        // 1 url的情况
        // 父级页面信息
        const parentPageParams = {
          activityCode: '',
          isLoginFlag: this.isLoginFlag,
          parentPage: 'thematicActivity',
          parentActivityCode: this.activityCode
        };
        // 专题活动配置类型为：链接，值为：积分商城全链接地址，则跳转积分商城,值为pointsMall不走这里，走标签(wx-open-launch-weapp)跳转
        if (pointsMallLinkJudge(link) !== PMLinkType.notMatch && linkIndex > -1 && item.linksArray && item.linksArray[linkIndex].lookUp === 'URL') {
          console.log('走到这里', link, 1);
          jumpToPointsMall(this.activityCode, link);
        } else if (link.indexOf(currentOrigin) > -1 && link.indexOf('hdmain') > -1) {
          console.log('走到这里', link, 4);
          // 链接为http开头的（或https）活动链接 , 或链接为小程序内部链接
          parentPageParams.activityCode = link.split('activityCode=')[1];
          const path = utils.appendParamsToURL(parentPageParams);
          self.$router.push({
            path: path
          });
          self.$store.commit('base/setIsRouterAlive', false);
          self.$nextTick(() => self.$store.commit('base/setIsRouterAlive', true));
        } else if (link.indexOf('/pages') > -1 || link.indexOf('pkg-custompage/activity') > -1) {
          console.log('走到这里', link, 5);
          // 小程序页面的情况或者打开腾讯荟聚小程序的情况
          if (this.loginType == 'wechat' && this.miniprogramFlag) {
            if (link.startsWith('/pages/tabBar')) {
              // 跳转首页的情况
              wx.miniProgram.switchTab({
                url: link
              });
            } else if (link.startsWith('pkg-custompage/activity')) {
              console.log('到腾讯荟聚');
              // 跳转首页再到腾讯荟聚的情况
              const objArray = item.linksArray.filter(currentValue => {
                if (currentValue.url === link) {
                  return currentValue;
                }
              });
              console.log('跳转信息objArray');
              console.log(objArray);
              this.showDialog(objArray[0]);
            } else {
              console.log('走到这里', link, 6);
              wx.miniProgram.navigateTo({
                url: link,
                success: function() {
                  console.log('success');
                },
                fail: function() {
                  console.log('跳转回小程序的页面fail');
                }
              });
            }
          } else if (this.loginType == 'Alipay') {
            if (this.miniprogramFlag) {
              my.reLaunch({
                url: link
              });
            } else {
              const linkArr = link.split('?');
              window.location.href = 'alipays://platformapi/startapp?appId=2021002121684220&page=' + linkArr[0] + '&query=' + linkArr[1];
            }
          }
        } else if (link.indexOf('/new-products-reserve/#/reserve-detail') > -1 && this.isClickNewProductUrl(item, linkIndex)) {
          // 专题活动图片楼层配有新品预定的链接https://retail-sit.test.hihonor.com/dist/new-products-reserve/#/reserve-detail?qt=sn&activityCode=HD202409002
          // 企业微信的场景先跳转小程序中转页，其他专题活动场景直接跳转新品预定页
          console.log('走到这里', link, 9);
          const url = encodeURIComponent(link);
          wx.miniProgram.navigateTo({
            url: `/subpackages/activity/pages/transferPage/transferPage?url=${url}`,
            success: function() {
              console.log('success');
            },
            fail: function() {
              console.log('跳转回小程序的页面fail');
            }
          });
        } else {
          console.log('走到这里', link, 7);
          // 3.不知道什么情形的
          console.info('link', link);
          if (link.includes('marketing/activityclubgroupmain/geography-club-info/')) {
            this.type = 'activityclubgroupmain';
            this.link = link;
            if (this.position.longitude && this.position.latitude) {
              this.goWork(link);
              return;
            }
            // 小程序/积分商城传过来的经纬度信息，如果没有传经纬度信息，需要h5拉起位置授权获取经纬度信息
            if (this.position.longitude && this.position.latitude) {
              this.goWork(link);
            } else {
              await this.getLocationMethods('activityclubgroupmain');
            }
          } else {
            console.log('走到这里', link, 8);
            // 专题活动配置类型为：H5，值为：积分商城全链接地址，则跳转积分商城,值为pointsMall不走这里，走标签(wx-open-launch-weapp)跳转,但不适配
            if (link && link.includes('h5/myHonor/points-mall')) {
              jumpToPointsMall(this.activityCode, link);
              return;
            }
            let obj = document.getElementById('links');
            obj.href = link;
            obj.click();
          }
        }
      }
    },
    goWork(link, index = 0) {
      console.log('link===========', link, this.position);
      const longitude = this.position.longitude || '116.4074';
      const latitude = this.position.latitude || '39.9042';
      const url = `${link}/${longitude}/${latitude}/2`;
      this.getStoreCode(link, longitude, latitude);
      const userToken = sessionStorage.getItem('userToken');
      const accessToken = sessionStorage.getItem('accessToken');
      const headers = {
        system_name: 'hd',
        traceId: utils.getuid(),
        'x-from': 'h5-hd',
        'x-user-token': userToken || '',
        'x-access-token': accessToken || ''
      };
      const cfgObj = {
        method: 'GET',
        url: url,
        withCredentials: true,
        async: false,
        headers: headers
      };
      const axios = require('axios');
      axios(cfgObj)
        .then(res => {
          if (res && res.data) {
            const r = res.data;
            if (r.code === 200) {
              const result = r.result;
              if (!result) {
                Toast('获取二维码失败');
                return;
              }
              if (this.type === 'communitycode') {
                this.$set(this.list[index], 'qrCodeImgUrl', result);
              } else {
                const obj = document.getElementById('links');
                obj.href = result;
                obj.click();
              }
            } else if (r.code === 505) {
              const isWeChat = this.isWeChat();
              let content = '';
              if (isWeChat) {
                content = '获取地理位置失败，请在手机设置里打开微信位置，授权允许访问才能继续使用本次服务';
              } else {
                content = '获取地理位置失败，请在手机设置里打开浏览器位置，授权允许访问才能继续使用本次服务';
              }
              Dialog.alert({
                title: '提示',
                message: content
              });
            } else {
              let content = '活动过于火爆，请稍后再试';
              if (r.message && r.message.length) {
                content = r.message;
              }
              Dialog.alert({
                title: '提示',
                message: content
              });
            }
          } else {
            Dialog.alert({
              title: '提示',
              message: '活动过于火爆，请稍后再试'
            });
          }
        })
        .catch(err => {
          console.log('catch====>', err);
          Dialog.alert({
            title: '提示',
            message: '活动过于火爆，请稍后再试'
          });
        });
    },
    getStoreCode(link, longitude, latitude) {
      // 活动id
      const id = link.substring(link.lastIndexOf('/') + 1);
      this.$api.get({
        noLoading: true,
        sc: 'mobileMarketing',
        url: `activityclubgroupmain/getChannelCode/${id}/${longitude}/${latitude}/2`,
        success: r => {
          if (r.code === 200 && r.result && r.result.channelCode) {
            const channelCode = r.result.channelCode;
            if (this.type === 'communitycode') {
              this.channelCode = channelCode;
            }
          }
        }
      });
    },
    isWeChat() {
      const ua = window.navigator.userAgent.toLowerCase();
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
      } else {
        return false;
      }
    },
    //记录点击事件
    recordClickEvent(link, item) {
      let self = this;
      // 浅拷贝对象，避免后续修改userBase导致直接操作vuex内存
      let userBase = Object.assign({}, self.$store.state.userInfo.userBase);
      let userInfo = sessionStorage.getItem('userInfo');
      if (userInfo) {
        userInfo = JSON.parse(userInfo);
        userBase = Object.assign(userBase, userInfo);
      }
      let userGender = '';
      if (userBase.sex == 1 || userBase.gender == 'm') {
        userGender = '1';
      } else if (userBase.sex == 2 || userBase.gender == 'f') {
        userGender = '2';
      }
      let params = {
        pageId: item.id,
        answerContent: link,
        userOpenid: userBase.openId || '',
        userUnionid: userBase.unionid || '',
        userGender: userGender,
        nickName: userBase.nickName || '',
        alipayUserId: this.alipayUserId,
        activityCode: self.activityObj.activityCode,
        loginType: sessionStorage.getItem('loginType'),
        associationActivityCode: sessionStorage.getItem('associationActivityCode')
      };
      let crtlParams = sessionStorage.getItem('crtlParams');
      if (crtlParams) {
        crtlParams = JSON.parse(crtlParams);
        params.loginType = crtlParams.loginType;
        params.answerTimes = 'once';
      }
      if (sessionStorage.getItem('connectionId')) {
        params.connectionId = sessionStorage.getItem('connectionId');
      }
      // 用户昵称脱敏
      if (params.nickName) {
        const privacyKeys = {
          nickName: '$PrivacyPlain$'
        };
        //隐私信息保存
        const privacyKeyList = [
          {
            nickName: 'nickName',
            typeText: 'NAME',
            labelText: 'mktMagicShareCpsNickName'
          }
        ];
        self.$utils.privacySave(privacyKeys, privacyKeyList, params);
      }
      return new Promise((resolve, reject) => {
        self.$api.post({
          sc: 'mobileMarketing',
          url: '/h5/projectActivity/saveUserInfoByProjectActivity',
          params,
          success: r => {
            resolve(r);
          }
        });
      });
    },
    /**mobileZuul
     * 请求商品信息
     * @param data: 商品楼层对象
     */
    async handleGetProduct(spuCodeList, data = []) {
      // hi荣耀
      const params = {
        spuCodes: spuCodeList
      };
      this.$api.post({
        sc: 'ses',
        url: config.listSpuBySpuCode,
        params,
        success: res => {
          const { status, result } = res;
          if (status == 'success' && result) {
            data.forEach(item => {
              if (item.pageType == 'spu' || item.pageType == 'channelspu') {
                const spuList = item.spuList || [];
                spuList.forEach(sItem => {
                  const detail = result[sItem.spuCode];
                  //返回对象有空字段
                  if (detail && detail.spuCode) {
                    if (detail.imgPath && (detail.imgPath.indexOf('http') != 0 || detail.imgPath.indexOf('https') != 0)) {
                      detail.imgPath = this.$utils.getImageUrl(detail.imgPath);
                    }
                    Object.keys(detail).forEach(key => {
                      this.$set(sItem, key, detail[key]);
                    });
                  }
                });
              }
            });
            this.list = this.dealActiveData(data);
          }
        }
      });
    },

    //返回小程序
    backXcx(item, type) {
      if (this.loginType == 'wechat') {
        //在微信小程序环境打开
        if (type === 'spu') {
          // 埋码事件：点击(专题页)首页商品楼层
          this.handleIndexThematicActivityProcess(item);
          wx.miniProgram.navigateTo({
            url: `/subpackages/index/pages/productDetailsGlobal/product-details-global?spuCode=${item.spuCode}&thematicActivityCode=${this.activityCode}`
          });
        } else if (type === 'channelspu') {
          // 埋码事件：点击(专题页)门店商品楼层
          this.handleStoreThematicActivityProcess(item);
          wx.miniProgram.navigateTo({
            url: `/subpackages/index/pages/productDetails/product-details?storeId=${item.channelCode || item.storeId || item.channelId}&spuCode=${
              item.spuCode
            }&skuCode=${item.skuCode}&thematicActivityCode=${this.activityCode}`
          });
        } else if (type === 'my') {
          wx.miniProgram.switchTab({
            url: `/pages/tabBar/my/my`
          });

          // 埋码事件：点击(专题页)个人中心
          this.handleCenterThematicActivityProcess();
        }
      } else if (this.loginType == 'Alipay') {
        //在支付宝小程序环境打开
        if (this.miniprogramFlag) {
          if (type === 'spu') {
            console.log(
              '跳hihonor首页商详==7==>miniprogramFlag=',
              this.miniprogramFlag,
              ',loginType =',
              this.loginType,
              ', thematicActivityCode=',
              this.activityCode,
              ',spuCode=',
              item.spuCode,
              ',skuCode=',
              item.skuCode
            );
            // 埋码事件：点击(专题页)首页商品楼层
            this.handleIndexThematicActivityProcess(item);
            my.navigateTo({
              url: `/subpackages/index/pages/productDetailsGlobal/product-details-global?spuCode=${item.spuCode}&thematicActivityCode=${this.activityCode}`
            });
          } else if (type === 'channelspu') {
            // 埋码事件：点击(专题页)门店商品楼层
            this.handleStoreThematicActivityProcess(item);
            console.log(
              '跳门店商详==2==>item.channelCode=',
              item.channelCode,
              ', thematicActivityCode=',
              this.activityCode,
              ',spuCode=',
              item.spuCode,
              ',skuCode=',
              item.skuCode,
              'miniprogramFlag=',
              this.miniprogramFlag,
              ',loginType =',
              this.loginType
            );
            my.navigateTo({
              url: `/subpackages/index/pages/productDetails/product-details?storeId=${item.channelCode || item.storeId || item.channelId}&spuCode=${
                item.spuCode
              }&skuCode=${item.skuCode}&thematicActivityCode=${this.activityCode}`
            });
          } else if (type === 'my') {
            my.switchTab({
              url: '/pages/tabBar/my/my'
            });
            // 埋码事件：点击(专题页)个人中心
            this.handleCenterThematicActivityProcess();
          }
        } else {
          //支付宝登录类型，在其他外部环境打开-优惠券、支付宝分期免息券
          if (['coupon', 'offinterest'].includes(type)) {
            if (item.skuScopeType === SkuScopeType.singleProduct) {
              //单商品跳详情
              console.log('跳hihonor首页商详==8==>', ', thematicActivityCode=', this.activityCode, ',spuCode=', item.spuCode, ',skuCode=', item.skuCode);
              let query = encodeURIComponent(`skuCode=${item.skuCodeList[0]}&groupCode=${item.groupCode}&thematicActivityCode=${this.activityCode}&isScheme=1`);
              window.location.href = `alipays://platformapi/startapp?appId=2021002121684220&page=subpackages/index/pages/productDetailsGlobal/product-details-global?${query}`;
            } else if (item.skuScopeType === SkuScopeType.moreProducts) {
              //多商品跳商品聚合页
              let query = encodeURIComponent(`groupCode=${item.groupCode}&isScheme=1&skuScopeType=${item.skuScopeType}`);
              window.location.href = `alipays://platformapi/startapp?appId=2021002121684220&page=subpackages/classify/pages/categories/categories?${query}`;
            } else {
              //全部商品跳选购页
              window.location.href = `alipays://platformapi/startapp?appId=2021002121684220&page=pages/tabBar/classify/classify`;
            }
          } else if (type === 'spu') {
            console.log('跳hihonor首页商详==9==>', ', thematicActivityCode=', this.activityCode, ',spuCode=', item.spuCode, ',skuCode=', item.skuCode);
            // 埋码事件：点击(专题页)首页商品楼层
            this.handleIndexThematicActivityProcess(item);
            let query = encodeURIComponent(`spuCode=${item.spuCode}&thematicActivityCode=${this.activityCode}&isScheme=1`);
            window.location.href = `alipays://platformapi/startapp?appId=2021002121684220&page=subpackages/index/pages/productDetailsGlobal/product-details-global&query=${query}`;
          } else if (type === 'channelspu') {
            // 埋码事件：点击(专题页)门店商品楼层
            this.handleStoreThematicActivityProcess(item);
            console.log(
              '跳门店商详==3==>item.channelCode=',
              item.channelCode,
              ', thematicActivityCode=',
              this.activityCode,
              ',spuCode=',
              item.spuCode,
              ',skuCode=',
              item.skuCode,
              'miniprogramFlag=',
              this.miniprogramFlag,
              ',loginType =',
              this.loginType
            );
            let query = encodeURIComponent(
              `storeId=${item.channelCode || item.storeId || item.channelId}&isScheme=1&spuCode=${item.spuCode}&skuCode=${item.skuCode}&thematicActivityCode=${
                this.activityCode
              }`
            );
            window.location.href = `alipays://platformapi/startapp?appId=2021002121684220&page=subpackages/index/pages/productDetails/product-details&query=${query}`;
          } else if (type === 'my') {
            window.location.href = 'alipays://platformapi/startapp?appId=2021002121684220&page=pages/tabBar/my/my';
            // 埋码事件：点击(专题页)个人中心
            this.handleCenterThematicActivityProcess();
          }
        }
      }
    },

    // 判断是否在小程序内
    handleMiniprogramJudge() {
      if (this.loginType === 'Alipay') {
        loadAlipayWebViewScript().then(res => {
          if (res) {
            //判断是否运行在支付宝小程序环境里
            my.getEnv(res => {
              console.log('支付宝小程序', res.miniprogram); //true
              this.miniprogramFlag = res.miniprogram;
            });
          }
        });
      } else if (this.loginType === 'wechat') {
        //判断是否在微信小程序环境
        this.miniprogramFlag = window.__wxjs_environment === 'miniprogram';
      }
    },
    showDialog(obj) {
      Dialog.confirm({
        message: '是否返回首页并跳转“腾讯荟聚”',
        confirmButtonColor: '#576B95',
        onfirmButtonText: '允许'
      })
        .then(() => {
          console.log(`reLaunch`);
          wx.miniProgram.reLaunch({
            url: `/pages/tabBar/index/index?url=${encodeURIComponent(obj.url)}&appId=${obj.appId}&miniProgram=${obj.lookUp}`
          });
        })
        .catch(() => {
          console.log(`/pages/tabBar/index/index?url=${obj.url}&appId=${obj.appId}&miniProgram=${obj.lookUp}`);
        });
    },
    dealActiveData(val) {
      for (let i = 0; i < val.length; i++) {
        const linksArray = [];
        if (val[i].firstLookup || val[i].firstMiniAppId) {
          linksArray[0] = {
            url: val[i].hrefFirst,
            lookUp: val[i].firstLookup,
            appId: val[i].firstAppId,
            miniAppId: val[i].firstMiniAppId // 第一个热区配置的第三方小程序 miniAppId
          };
        }
        if (val[i].secondLookup || val[i].secondMiniAppId) {
          linksArray[1] = {
            url: val[i].hrefSecond,
            lookUp: val[i].secondLookup,
            appId: val[i].secondAppId,
            miniAppId: val[i].secondMiniAppId // 第二个热区配置的第三方小程序 miniAppId
          };
        }
        if (val[i].thirdLookup) {
          linksArray[2] = {
            url: val[i].hrefThird,
            lookUp: val[i].thirdLookup,
            appId: val[i].thirdAppId
          };
        }
        if (val[i].fourLookup) {
          linksArray[3] = {
            url: val[i].hrefFour,
            lookUp: val[i].fourLookup,
            appId: val[i].fourAppId
          };
        }
        if (val[i].pageType === 'draw') {
          this.drawFlag = true;
        }
        val[i].linksArray = linksArray;
      }
      return val;
    },
    handleActivityInfo(val) {
      let arr = [];
      val.forEach(item => {
        //优惠券 代金券 权益品
        if (['coupon', 'voucher', 'exchangegoods'].includes(item.pageType) && item.activityPageRewardSettingList) {
          arr = arr.concat(item.activityPageRewardSettingList);
        }
      });
      arr = arr.map(item => ({
        exchangeGoodsType: item.goodsType, //0:虚拟,1:实物,2:优惠券,3:积分,4:代金券,5:赠品券
        collectionType: item.collectionType, //领取类型(1:邮寄(实物)/线上兑换(虚拟);2:到店自提(实物)/线下核销(虚拟);3:线下核销发串码(虚拟));4:免单抽奖
        businessId: item.activityCode, //普通大转盘传recordId、定时盲盒和定时新盲盒传activityCode、专题传activityCode、签到传bigwheelRewardRecodeId
        businessType: '7', //业务类型 12.签到  7.专题活动 9.大转盘
        goodsId: item.goodsId
      }));
      return arr;
    },
    async handelPaused() {
      this.initData();
    },
    handleMiniProgramLogin() {
      // 微信小程序场景
      if (this.loginType === 'wechat') {
        wx.miniProgram.postMessage({
          activityUrl: encodeURIComponent(this.activityUrl)
        });
        wx.miniProgram.reLaunch({
          url: '/pages/tabBar/index/index?activityUrl=' + encodeURIComponent(this.activityUrl),
          success: () => {
            console.log('跳转回小程序的页面success');
          },
          fail: res => {
            console.log('跳转回小程序的页面fail', res);
          }
        });
      } else if (this.loginType === 'Alipay') {
        //在支付宝小程序环境打开
        console.log('this.miniProgramFlag', this.miniprogramFlag);
        if (this.miniprogramFlag) {
          my.postMessage({
            activityUrl: encodeURIComponent(this.activityUrl)
          });
          my.reLaunch({
            url: '/pages/tabBar/index/index?activityUrl=' + encodeURIComponent(this.activityUrl)
          });
          console.log('支付宝小程序环境');
          console.log(this.activityUrl);
        } else {
          //在支付宝内部浏览器打开
          const query = encodeURIComponent(`activityUrl=${this.activityUrl}`);
          console.log('支付宝浏览器环境');
          console.log(query);
          window.location.href = 'alipays://platformapi/startapp?appId=2021002121684220&page=pages/tabBar/index/index&query=' + query;
        }
      }
    },
    // 点了第几块热区且热区lookup是新品预定
    isClickNewProductUrl(item, linkIndex) {
      if (linkIndex === 0 && item.firstLookup === 'XN') {
        return true;
      } else if (linkIndex === 1 && item.secondLookup === 'XN') {
        return true;
      } else if (linkIndex === 2 && item.thirdLookup === 'XN') {
        return true;
      } else if (linkIndex === 3 && item.fourLookup === 'XN') {
        return true;
      } else {
        return false;
      }
    },
    // 点击关闭登录弹窗
    handleCloseLoginPop() {
      this.isClickClosePop = true;
    }
  }
};
</script>

<style scoped lang="scss">
.thematicActivity {
  min-height: 100vh;
  width: 100vw;
  .appointment {
    position: fixed;
    bottom: 15px;
    width: 100%;
    text-align: center;
    .appointment-wrap {
      position: relative;
      width: 100%;
    }
    .appointment-login-btn {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow: hidden;
    }
    .appointment-btn {
      width: calc(100% - 60px);
      position: relative;
    }
  }

  .equity-package-padding {
    padding: 6px 0;
  }

  .live-code {
    position: relative !important;
  }
}
img {
  width: 100% !important;
  display: block;
}

.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  word-break: break-all;
}

.countdownTime {
  position: fixed;
  top: 8px;
  right: 8px;
  min-width: 80px;
  padding: 0 10px;
  height: 40px;
  background-color: rgba(219, 197, 197, 0.5);
  color: white;
  font-size: 16px;
  line-height: 40px;
  text-align: center;
  border-radius: 20px;
  z-index: 666;
}

.goods {
  width: 100%;
  padding: 10px 4% 0px 4%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  &.height-goods {
    min-height: 300px;
  }
  .goods_item {
    margin-bottom: 10px;
    width: 48.6%;
    background: #ffffff;
    border-radius: 10px;
    padding: 17px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    text-align: center;
    color: #1c1c1c;
    .goods_item_img {
      width: 100%;
      max-width: 152px;
      max-height: 152px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 9px;
      position: relative;
      &::before {
        display: block;
        content: '';
        width: 100%;
        padding-top: 100%;
      }
      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        position: absolute;
      }
    }
  }
}

// 因为如果底部出现了预约xx按钮 按钮的高度和bottom 的和为60 因此 如果又配置了 商品之类的 底部要撑上去60  防止按钮遮挡 商品
.sumOfReservationGuideBtn_height_Bottom {
  padding-bottom: 60px;
}

.float-button {
  position: fixed;
  bottom: 80px;
  right: 16px;
  z-index: 9899;
  width: 50px;
  height: 50px;
  cursor: pointer;
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;

  img {
    width: 48px;
    height: 48px;
    display: block;
    max-width: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/thematicActivity.vue